import {
  logoutAdmin,
  logoutUser,
  verifyAdmin,
  verifyUser,
} from "../Redux/Auth/AuthActions";
import { createBrowserRouter, RouterProvider } from "react-router";
import DeleteProfile from "../Pages/DeleteProfile/DeleteProfile";
import GuestParking from "../Pages/GuestParking/GuestParking";
import Loading from "../Components/Common/Loading/Loading";
import GuestInvite from "../Pages/GuestInvite/GuestInvite";
import GuestAccess from "../Pages/GuestAccess/GuestAccess";
import { AppDispatch, RootState } from "../Redux/store";
import { useDispatch, useSelector } from "react-redux";
import { getStorage } from "../Util/storageHelper";
import Error404 from "../Pages/Error404/Error404";
import Support from "../Pages/Support/Support";
import getAdminRoutes from "./AdminRoutes";
import { useEffect, useMemo } from "react";
import Terms from "../Pages/Terms/Terms";
import userRoutes from "./UserRoutes";

const Routes = () => {
  const dispatch = useDispatch<AppDispatch>();

  const { verifyLoading, adminPermissions } = useSelector(
    (state: RootState) => state.auth,
  );

  const router = useMemo(
    () =>
      createBrowserRouter([
        ...userRoutes,
        ...getAdminRoutes(adminPermissions),
        {
          path: "/terms",
          element: <Terms />,
        },
        {
          path: "/support",
          element: <Support />,
        },
        {
          path: "/deleteprofile",
          element: <DeleteProfile />,
        },
        {
          path: "/guest/invites/:uuid",
          element: <GuestInvite />,
        },
        {
          path: "/guest/access/:uuid",
          element: <GuestAccess />,
        },
        {
          path: "/guest/parking/:buildingId",
          element: <GuestParking />,
        },
        {
          path: "*",
          element: <Error404 />,
        },
      ]),
    [adminPermissions],
  );

  useEffect(() => {
    const handleUserVerify = () => {
      const token = getStorage("token");
      if (token) {
        dispatch(verifyUser(token?.token));
      } else {
        dispatch(logoutUser());
      }
    };

    const handleAdminVerify = () => {
      const adminData = getStorage("adminData");

      if (adminData) {
        dispatch(verifyAdmin(adminData?.adminData));
      } else {
        dispatch(logoutAdmin());
      }
    };

    const isAdminRoute = window.location.pathname.includes("/admin");
    if (isAdminRoute) {
      handleAdminVerify();
    } else {
      handleUserVerify();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (verifyLoading) {
    return <Loading />;
  }

  return <RouterProvider router={router} />;
};

export default Routes;
